import React from 'react';

import Text from '@components/common/Text/Text';

import Element = React.JSX.Element;
import css from './NotificationBloc.module.scss';

type NotificationBlocProps = {
    variant: string;
    message: string | Element;
    onResetVisibility?: (boolean) => void;
    customClass?: string;
    hideclose?: boolean;
    isNotClosable?: boolean;
};

type SvgProps = {
    color: string;
};

const NotificationBloc = ({
    variant,
    message,
    onResetVisibility,
    customClass,
    isNotClosable,
    hideclose,
}: NotificationBlocProps) => {
    const AlertIcon = ({ color, ...props }: SvgProps) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
                <path
                    fill={color}
                    d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 11a1 1 0 110 2 1 1 0 010-2zm0-8a1 1 0 011 1v5a1 1 0 01-2 0V8a1 1 0 011-1z"
                />
            </svg>
        );
    };

    const CloseIcon = ({ color, ...props }: SvgProps) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                    fill={color}
                    d="M13.41 12l4.3-4.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 00-1.42 1.42l4.3 4.29-4.3 4.29a.997.997 0 000 1.42.997.997 0 001.42 0l4.29-4.3 4.29 4.3a.997.997 0 001.42 0 .997.997 0 000-1.42L13.41 12z"
                />
            </svg>
        );
    };

    const renderColor = () => {
        if (variant === 'error') {
            return '#fb2838';
        }
        if (variant === 'warning') {
            return '#EB853D';
        }
        if (variant === 'success') {
            return '#2BE283';
        }
    };

    return (
        <div className={`${css.notification} ${css['notification__' + variant]} ${customClass || ''} `}>
            <AlertIcon color={renderColor()} />
            <Text variant={'caption_02'} color={renderColor()} customClass={css.notification__message}>
                {message}
            </Text>
            {!isNotClosable && (
                <div className={css.notification__close} onClick={() => onResetVisibility(false)}>
                    {!hideclose && <CloseIcon color={renderColor()} />}
                </div>
            )}
        </div>
    );
};
export default NotificationBloc;
